module.exports = __webpack_public_path__ + "media/the-video.7ad18127.mp4";